<template>
  <div class="content-warp">
    <div class="content-panle bg-white">
      <div class="table-operation-area">
        <div class="btn-area-inline">
          <TableTips :total="pagination.total" />
        </div>
        <a-form class="search-form" layout="inline" :form="listSearchForm" @submit.prevent="handleSearchList">
          <a-form-item>
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              style="width: 160px"
              :placeholder="$t('alarmMana.deviceTypesTxt')"
              :options="searchDeviceTypeOptions"
              v-decorator="['deviceType', { initialValue: '' }]"
            />
          </a-form-item>
          <a-form-item>
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              style="width: 160px"
              :placeholder="$t('alarmMana.alarmTypeTxt')"
              :options="searchAlarmTypeOptions"
              v-decorator="['alarmType', { initialValue: '' }]"
            />
          </a-form-item>

          <a-form-item>
            <a-range-picker
              style="width: 280px"
              format="YYYY-MM-DD"
              :placeholder="[$t('alarmMana.startTimeTxt'), $t('alarmMana.endTimeTxt')]"
              :ranges="searchDateRangesBtn"
              v-decorator="['dateRange', {initialValue: [moment(), moment()]}]"
              :disabledDate="current => current > moment()"
            />
          </a-form-item>                

          <a-form-item>
            <a-input 
              style="width: 160px"
              type="text"
              v-decorator="['keyword']" 
              :placeholder="$t('alarmMana.deviceSNOrNameTxt')" >
              <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>

          <a-form-item style="margin-right:0">
            <a-button type="primary" html-type="submit" :loading="loading">{{$t('alarmMana.searchBtn')}}</a-button>
          </a-form-item>
        </a-form>
      </div>

      <a-table
        style="min-height: 584px"
        :columns="tableColumns" 
        :dataSource="tableData"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
      </a-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { getAlarm } from '@/api/alarmMana';
import TableTips from '@/components/TableTips';
export default {
  name: 'alarmManaIndex',
  components: { TableTips },
  data() {
    return {

      listSearchForm: this.$form.createForm(this),
      searchDeviceTypeOptions: [],
      searchAlarmTypeOptions: [],

      searchDeviceType: undefined,
      searchAlarmType: undefined,
      searchKeyword: '',
      searchFromDate: moment().format('YYYY-MM-DD'),
      searchToDate: moment().format('YYYY-MM-DD'),
      searchDateRangesBtn: this.getSearchDateRangesBtn(),

      loading: false, // 列表内容是否在加载中
      tableData: [], // 列表数据源
      tableColumns: this.getTableColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      showImgModalVisible: false,
      showImgUrl: ''
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      alarmType: state => state.enumsStore.enumsData.alarmType,
      deviceType: state => state.enumsStore.enumsData.deviceType
    })
  },
  watch: {
    lang: function (lang) {
      this.tableColumns = this.getTableColumns()
      this.searchDateRangesBtn = this.getSearchDateRangesBtn()

      this.searchDeviceTypeOptions = [].concat([{ title: this.$t('alarmMana.option_allDeviceType'), value: '', key: 'all' }], this.deviceType)
      this.searchAlarmTypeOptions = [].concat([{ title: this.$t('alarmMana.option_allAlarmType'), value: '', key: 'all' }], this.alarmType)
    }
  },
  created() {
    this.searchDeviceTypeOptions = [].concat([{ title: this.$t('alarmMana.option_allDeviceType'), value: '', key: 'all' }], this.deviceType)
    this.searchAlarmTypeOptions = [].concat([{ title: this.$t('alarmMana.option_allAlarmType'), value: '', key: 'all' }], this.alarmType)

    this.getListData()
  },
  methods: {
    moment,
    getTableColumns() {
      return [
        {
          title: this.$t('alarmMana.listAlarmType'),
          dataIndex: 'alarmTypeName',
          width: '15%'
        },
        {
          title: this.$t('alarmMana.listDeviceSN'),
          dataIndex: 'deviceSn',
          width: '15%'
        },
        {
          title: this.$t('alarmMana.listDeviceName'),
          dataIndex: 'deviceName',
          width: '15%'
        },
        {
          title: this.$t('alarmMana.listAlarmTime'),
          dataIndex: 'alarmAt',
          width: '20%'
        },
        {
          title: this.$t('alarmMana.listAlarmDiscribe'),
          dataIndex: 'description'
        }
      ]
    },
    // 获取时间段选择插件快捷按钮内容
    getSearchDateRangesBtn() {
      const btns = {}
      btns[this.$t('alarmMana.aWeekBeforeBtn')] = [this.moment().subtract(6, 'days'), this.moment()]
      btns[this.$t('alarmMana.oneMonthBeforeBtn')] = [this.moment().subtract(1, 'months'), this.moment()]
      btns[this.$t('alarmMana.threeMonthsBeforeBtn')] = [this.moment().subtract(3, 'months'), this.moment()]
      return btns
    },
    // 搜素列表
    handleSearchList() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          // console.log('handleSearchList', values)
          
          this.searchDeviceType = values.deviceType || undefined
          this.searchAlarmType = values.alarmType || undefined
          this.searchKeyword = values.keyword
          this.searchFromDate = values.dateRange[0].format('YYYY-MM-DD')
          this.searchToDate = values.dateRange[1].format('YYYY-MM-DD')

          this.pagination.current = 1
          this.getListData()
        }
      });
    },
    // 获取列表数据
    async getListData() {
      try {
        this.loading = true;
        const res = await getAlarm({
          deviceTypeCodes: this.searchDeviceType,
          alarmType: this.searchAlarmType,
          fromDate: this.searchFromDate,
          toDate: this.searchToDate,
          keyword: this.searchKeyword,
          perPage: this.pagination.pageSize,
          page: this.pagination.current
        })
        this.loading = false;

        this.tableData = this.createAlarmTableData(res.data.collection);
        this.pagination.total = res.data.size;
      } catch (error) {
        this.loading = false;
      }
    },
    createAlarmTableData(data) {
      return data.map(item => {
        return {
          key: Math.random(),
          id: Math.random(),
          alarmTypeName: item.alarmTypeName,
          deviceSn: item.deviceSn,
          deviceName: item.deviceName,
          alarmAt: item.alarmAt,
          description: item.description
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      // console.log('-------handleTableChange------', pagination);
      this.pagination.current = pagination.current;
      this.getListData();
    }
  }
  
}
</script>

<style scoped>
  .show-img-modal .ant-modal{
    top: 30px
  }
</style>